module.exports = __webpack_public_path__ + "img/logo.297942aa.png";